import {
  UPSTOX_BASE_URL,
  PRIVACY_POLICY_URL,
  CAREERS_URL,
  INVESTOR_CHARTER_URL,
  CLIENT_BANK_DETAILS_URL,
} from '../../Models/Actions/Footer/url-helper';

export const copyRightData = [
  {
    text: 'Sitemap',
    link: `${UPSTOX_BASE_URL}sitemap/`,
  },
  {
    text: 'Terms of Use and Privacy Policy',
    link: PRIVACY_POLICY_URL,
  },
  {
    text: 'Trust & Security',
    link: `${UPSTOX_BASE_URL}trust-security/`,
  },
  {
    text: 'Careers',
    link: CAREERS_URL,
  },
  {
    text: 'Investor Charter',
    link: INVESTOR_CHARTER_URL,
  },
  {
    text: 'Client Bank Details',
    link: CLIENT_BANK_DETAILS_URL,
  },
];
